import FlexPane from './_flex-pane.js'
import SelectableButtonGroup from './_selectable-button-group.js'
import Text from './_text.js'
import Image from './_image.js'
import AbsolutePane from './_absolute-pane.js'

export default {
  name: 'CrossSellMenu',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          justifyContent: 'flex-start',
        },
      },
    },
    linkButtons: {
      configSet: SelectableButtonGroup,
      configValues: {
        container: {
          style: {
            flexBasis: '40px',
          },
        },
        selectableButton: {
          unselected: {
            style: {
              base: {
                flexGrow: 0,
                flexBasis: '96px',
                minHeight: '40px',
              },
            },
          },
          selected: {
            style: {
              base: {
                flexGrow: 0,
                flexBasis: '96px',
                minHeight: '40px',
              },
            },
          },
        },
      },
    },
    linkLabel: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
          alignSelf: 'center',
        },
      },
    },
    linkImageContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          flexBasis: '16px',
          padding: '0 8px 0 0',
        },
      },
    },
    linkImage: {
      configSet: Image,
      configValues: {
        style: {
          flexBasis: '16px',
        },
      },
    },
    linkHighlightIconContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          top: 0,
          right: 0,
          width: '30px',
          height: '20px',
          zIndex: 701,
        },
      },
    },
    linkHighlightIcon: {
      configSet: Image,
      configValues: {
        src: 'cross-sell/new-tag.png',
      },
    },
    links: [
    ],
  },
  meta: {
    extendable: false,
  },
}
